// components/Announcements.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSeo } from '../hooks/useSeo';
import Navbar from './Navbar';
import Footer from './Footer';
import Contact from './Contact';
import Donate from './Donate';

const Announcements = () => {
  useSeo({
    title: "Announcements - Progressive Forces of Afghanistan Movement",
    description: "Official announcements and statements from PFA Movement in multiple languages."
  });
  
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  // Debug logging
  useEffect(() => {
    console.log('Announcements component mounted');
    console.log('Current language:', i18n.language);
    console.log('Announcements data:', announcementsData);
  }, [i18n.language]);

  // Sample announcements data
const announcementsData = [
  
  {
  id: 10,
  date: "November 25, 2025",
  title: {
    en: "Joint Statement on the Occasion of the International Day for the Elimination of Violence against Women",
    fa: "بیانیه مشترک به مناسبت روز بین‌المللی محو خشونت علیه زنان",
    ps: "د ښځو پر وړاندې د تاوتریخوالي د له منځه وړلو نړیوالې ورځې په مناسبت مشترکه بیانیه"
  },
  files: [
    {
      language: "English",
      code: "en",
      name: "Joint_Statement_on_the_Occasion_EN.pdf",
      url: "/announcements/Joint_Statement_on_the_Occasion_EN.pdf",
      size: "1.8 MB"
    },
    {
      language: "Persian",
      code: "fa",
      name: "Joint_Statement_on_the_Occasion_FA.pdf",
      url: "/announcements/Joint_Statement_on_the_Occasion_FA.pdf",
      size: "1.9 MB"
    },
    {
      language: "Pashto",
      code: "ps",
      name: "Joint_Statement_on_the_Occasion_PA.pdf",
      url: "/announcements/Joint_Statement_on_the_Occasion_PA.pdf",
      size: "1.9 MB"
    }
  ],
  description: {
    en: "A joint statement addressed to international bodies expressing deep concern over the catastrophic human rights situation in Afghanistan, condemning the Taliban's systematic suppression of women and their exclusion from public life, which has exposed them to structural violence, poverty, and deprivation of dignity.",
    fa: "بیانیه‌ای مشترک خطاب به نهادهای بین‌المللی که نگرانی عمیق از وضعیت فاجعه‌بار حقوق بشر در افغانستان ابراز داشته و سرکوب سیستماتیک زنان و حذف آنان از عرصه‌های عمومی توسط طالبان را محکوم می‌کند؛ اقداماتی که زنان را در معرض خشونت ساختاری، فقر و محرومیت از کرامت انسانی قرار داده است.",
    ps: "یوه مشترکه بیانیه چې نړیوالو ادارو ته یې د افغانستان د بشري حقونو په فاجعه‌واره وضعیت څخه خپله ژورۀ اندیښنه څرګنده کړې ده او د طالبانو د ښځو سیستماتیک ځپل او د هغوی له ټولنیزو، زده‌کړې او مسلکي ډګرونو څخه حذف کول غندي؛ هغه اقدامات چې ښځې یې د ساختماني تاوتریخوالي، بې وزلي او د بشري عزت څخه محرومیت سره مخ کړې دي."
  }
},
  {
  id: 9,
  date: "November 25, 2025",
  title: {
    en: "Quadripartite Resolution of Afghan Women's Protest Movements: Our Freedom is Non-Negotiable",
    fa: "قطعنامه چهارجانبه جنبش‌های اعتراضی زنان افغانستان: آزادی ما غریقابل مذاکره است",
    ps: "د افغانستان د ښځو د اعتراضي خوځښتونو د څلور اړخیزو قطعنامه: زموږ ازاده غبرګونې وړ نه ده"
  },
  files: [
    {
      language: "Persian", 
      code: "fa",
      name: "Quadripartite_Resolution_Nov25_2025_FA.pdf",
      url: "/announcements/Quadripartite_Resolution_Nov25_2025_FA.pdf",
      size: "2.4 MB"
    }
  ],
  description: {
    en: "A quadripartite resolution issued by four Afghan women's protest movements during the Week for the Elimination of Violence Against Women, declaring 'Afghan women will not surrender; our freedom is non-negotiable' and outlining demands for international action.",
    fa: "قطعنامه چهارجانبه صادر شده توسط چهار جنبش اعتراضی زنان افغانستان در هفته محو خشونت علیه زنان با شعار 'زنان افغانستان تسلیم نمی‌شوند؛ آزادی ما غریقابل مذاکره است' و شامل خواسته‌هایی برای اقدام بین‌المللی.",
    ps: "د افغانستان د ښځو د څلور اعتراضي خوځښتونو لخوا صادر شوې څلور اړخیزه قطعنامه چې 'افغان ښځې تسلیم نه کیږي؛ زموږ ازادي د خبرو اترو وړ نه ده' اعلان کوي او د نړیوال عمل لپاره غوښتنې څرګندوي."
  }
},
 {
  id: 8,
  date: "November 25, 2025",
  title: {
    en: "Joint Statement: Over 113 Organizations and Movements on the International Day for the Elimination of Violence against Women",
    fa: "بیانیه مشترک: بیش از ۱۱۳ نهاد، انجمن، سازمان و جنبش اعتراضی به مناسبت روز بین‌المللی محو خشونت علیه زنان",
    ps: "د ۱۱۳ څخه زیاتو مؤسسو، ټولنو، سازمانونو او اعتراضي خوځښتونو مشترک بیان: د ښځو پر وړاندې د تاوتریخوالی له منځه وړلو نړیواله ورځ"
  },
  files: [
    {
      language: "English",
      code: "en",
      name: "Joint_Statement_Nov25_2025_EN.pdf",
      url: "/announcements/Joint_Statement_Nov25_2025_EN.pdf",
      size: "1.8 MB"
    },
    {
      language: "Persian",
      code: "fa",
      name: "Joint_Statement_Nov25_2025_FA.pdf",
      url: "/announcements/Joint_Statement_Nov25_2025_FA.pdf",
      size: "1.9 MB"
    },
    {
      language: "Pashtu",
      code: "ps",
      name: "Joint_Statement_Nov25_2025_PS.pdf",
      url: "/announcements/Joint_Statement_Nov25_2025_PS.pdf",
      size: "1.8 MB"
    }
  ],
  description: {
    en: "A joint statement by over 113 organizations, associations, and protest movements on the occasion of the International Day for the Elimination of Violence against Women.",
    fa: "بیانیه مشترک بیش از ۱۱۳ نهاد، انجمن، سازمان و جنبش اعتراضی به مناسبت روز بین‌المللی محو خشونت علیه زنان.",
    ps: "د ۱۱۳ څخه زیاتو مؤسسو، ټولنو، سازمانونو او اعتراضي خوځښتونو مشترک بیان د ښځو پر وړاندې د تاوتریخوالی له منځه وړلو نړیوالې ورځې په مناسبت."
  }
},
  {
    id: 1,
    date: "October 24, 2025",
    title: {
      en: "Joint Statement: Over 113 Civil Society Organizations on Forced Deportation of Vulnerable Afghan Migrants from Pakistan",
      fa: "بیانیه مشترک: بیش از ۱۱۳ انجمن و جنبش مدنی درباره اخراج اجباری مهاجران آسیب‌پذیر افغانستان از پاکستان",
      ps: "د ۱۱۳ څخه زیاتو مدني ټولنو او خوځښتونو مشترک بیان: د افغانستان د زیانمنو کډوالو اجباري شړل له پاکستان څخه",
      ur: "مشترکہ بیان: پاکستان سے کمزور افغان مہاجرین کی جبری بے دخلی کے بارے میں 113 سے زائد سول سوسائٹی تنظیمیں اور تحریکیں"
    },
    files: [
      {
        language: "English",
        code: "en",
        name: "PFA_Announcement_Oct24_2025_EN.pdf",
        url: "/announcements/PFA_Announcement_Oct24_2025_EN.pdf",
        size: "2.1 MB"
      },
      {
        language: "Persian",
        code: "fa",
        name: "PFA_Announcement_Oct24_2025_FA.pdf",
        url: "/announcements/PFA_Announcement_Oct24_2025_FA.pdf",
        size: "2.3 MB"
      },
      {
        language: "Pashtu",
        code: "ps",
        name: "PFA_Announcement_Oct24_2025_PS.pdf",
        url: "/announcements/PFA_Announcement_Oct24_2025_PS.pdf",
        size: "2.2 MB"
      },
      {
        language: "Urdu",
        code: "ur",
        name: "PFA_Announcement_Oct24_2025_UR.pdf",
        url: "/announcements/PFA_Announcement_Oct24_2025_UR.pdf",
        size: "2.4 MB"
      }
    ],
    description: {
      en: "A joint statement signed by over 113 civil society organizations and movements expressing grave concern about the forced deportation of vulnerable Afghan migrants from Pakistan and calling for immediate international intervention.",
      fa: "بیانیه مشترک بیش از ۱۱۳ انجمن و جنبش مدنی که نگرانی شدید خود را درباره اخراج اجباری مهاجران آسیب‌پذیر افغان از پاکستان ابراز کرده و خواستار مداخله فوری بین‌المللی شده‌اند.",
      ps: "د ۱۱۳ څخه زیاتو مدني ټولنو او خوځښتونو لخوا لاسلیک شوی مشترک بیان چې د پاکستان څخه د افغانستان د زیانمنو کډوالو د اجباري شړلو په اړه خپله شدیده اندیښنه څرګندوي او د نړیوالې مرستې غوښتنه کوي.",
      ur: "113 سے زائد سول سوسائٹی تنظیموں اور تحریکوں کا مشترکہ بیان جس میں پاکستان سے کمزور افغان مہاجرین کی جبری بے دخلی پر گہری تشنگی کا اظہار کیا گیا ہے اور فوری بین الاقوامی مداخلت کی اپیل کی گئی ہے۔"
    }
  },
  {
    id: 2,
    date: "August 15, 2025",
    title: {
      en: "Global Declaration: Fourth Anniversary of Taliban Takeover - No Recognition of Taliban Regime",
      fa: "اعلامیه جهانی: چهارمین سالگرد تسلط طالبان - عدم رسمیت‌شناسی رژیم طالبان",
      de: "Globale Erklärung: Vierter Jahrestag der Taliban-Übernahme - Keine Anerkennung des Taliban-Regimes",
    },
    files: [
      {
        language: "English",
        code: "en",
        name: "Global_Declaration_August_15_2025_EN.pdf",
        url: "/announcements/Global_Declaration_August_15_2025_EN.pdf",
        size: "1.5 MB"
      },
      {
        language: "Persian",
        code: "fa",
        name: "Global_Declaration_August_15_2025_FA.pdf",
        url: "/announcements/Global_Declaration_August_15_2025_FA.pdf",
        size: "1.6 MB"
      },
      {
        language: "German",
        code: "de",
        name: "Global_Declaration_August_15_2025_DE.pdf",
        url: "/announcements/Global_Declaration_August_15_2025_DE.pdf",
        size: "1.7 MB"
      },
      {
        language: "Spanish",
        code: "es",
        name: "Global_Declaration_August_15_2025_ES.pdf",
        url: "/announcements/Global_Declaration_August_15_2025_ES.pdf",
        size: "1.5 MB"
      },
      {
        language: "French",
        code: "fr",
        name: "Global_Declaration_August_15_2025_FR.pdf",
        url: "/announcements/Global_Declaration_August_15_2025_FR.pdf",
        size: "1.6 MB"
      },
      {
        language: "Norwegian",
        code: "no",
        name: "Global_Declaration_August_15_2025_NO.pdf",
        url: "/announcements/Global_Declaration_August_15_2025_NO.pdf",
        size: "1.4 MB"
      }
    ],
    description: {
      en: "Global declaration by protesting women, civil activists, and human rights defenders on the fourth anniversary of Taliban takeover, condemning gender apartheid and calling for no recognition of the Taliban regime.",
      fa: "اعلامیه جهانی زنان معترض، فعالان مدنی و مدافعان حقوق بشر در چهارمین سالگرد تسلط طالبان، محکومیت آپارتاید جنسیتی و درخواست برای عدم رسمیت‌شناسی رژیم طالبان.",
      de: "Globale Erklärung von protestierenden Frauen, zivilen Aktivisten und Menschenrechtsverteidigern zum vierten Jahrestag der Taliban-Übernahme, Verurteilung des Geschlechter-Apartheids und Aufruf zur Nichtanerkennung des Taliban-Regimes.",
    }
  },
  {
    id: 3,
    date: "July 26, 2025",
    title: {
      en: "Resolution: Rejection of Taliban Representation in Afghan Diplomatic Missions in Germany",
      fa: "قطعنامه: مخالفت با نمایندگی طالبان در مأموریت‌های دیپلماتیک افغانستان در آلمان",
      de: "Resolution: Ablehnung der Taliban-Vertretung in afghanischen diplomatischen Missionen in Deutschland"
    },
    files: [
      {
        language: "English",
        code: "en",
        name: "Resolution_Taliban_Representation_Germany_EN.pdf",
        url: "/announcements/Resolution_Taliban_Representation_Germany_EN.pdf",
        size: "1.7 MB"
      },
      {
        language: "Persian", 
        code: "fa",
        name: "Resolution_Talban_Representation_Germany_FA.pdf",
        url: "/announcements/Resolution_Taliban_Representation_Germany_FA.pdf",
        size: "1.8 MB"
      }
    ],
    description: {
      en: "Resolution adopted by Afghan civil society members, women's rights defenders, and exiled activists in Germany against the handover of Afghan embassy and consulates to Taliban representatives, citing security concerns and human rights violations.",
      fa: "قطعنامه تصویب شده توسط اعضای جامعه مدنی افغانستان، مدافعان حقوق زنان و فعالان تبعیدی در آلمان علیه سپردن سفارت و قنسولگری‌های افغانستان به نمایندگان طالبان، با اشاره به نگرانی‌های امنیتی و نقض حقوق بشر.",
      de: "Von afghanischen Zivilgesellschaftsmitgliedern, Frauenrechtsverteidigern und exilierten Aktivisten in Deutschland verabschiedete Resolution gegen die Übergabe der afghanischen Botschaft und Konsulate an Taliban-Vertreter, unter Hinweis auf Sicherheitsbedenken und Menschenrechtsverletzungen."
    }
  },
  {
    id: 4,
    date: "July 2025",
    title: {
      en: "Open Letter to German Government: Stop Normalization with Taliban and Deportation of Afghan Refugees",
      fa: "نامه سرگشاده به دولت آلمان: توقف عادی‌سازی با طالبان و توقف اخراج پناهجویان افغان",
      de: "Offener Brief an die deutsche Regierung: Stopp der Normalisierung mit den Taliban und Abschiebung afghanischer Flüchtlinge"
    },
    files: [
      {
        language: "Persian",
        code: "fa",
        name: "Open_Letter_German_Government_FA.pdf",
        url: "/announcements/Open_Letter_German_Government_FA.pdf",
        size: "1.9 MB"
      },
      {
        language: "English",
        code: "en",
        name: "Open_Letter_German_Government_EN.pdf",
        url: "/announcements/Open_Letter_German_Government_EN.pdf",
        size: "1.8 MB"
      },
      {
        language: "German",
        code: "de",
        name: "Open_Letter_German_Government_DE.pdf",
        url: "/announcements/Open_Letter_German_Government_DE.pdf",
        size: "1.9 MB"
      }
    ],
    description: {
      en: "Open letter to the German government expressing deep concern about plans to normalize relations with the Taliban and deport Afghan asylum seekers, calling for adherence to international human rights obligations.",
      fa: "نامه سرگشاده به دولت آلمان در بیان نگرانی عمیق درباره برنامه‌های عادی‌سازی روابط با طالبان و اخراج پناهجویان افغان، با درخواست پایبندی به تعهدات بین‌المللی حقوق بشر.",
      de: "Offener Brief an die deutsche Regierung, der tiefe Besorgnis über Pläne zur Normalisierung der Beziehungen zu den Taliban und zur Abschiebung afghanischer Asylsuchender ausdrückt und zur Einhaltung internationaler Menschenrechtsverpflichtungen aufruft."
    }
  },
  {
    id: 5,
    date: "Jul 4 2025",
    title: {
      en: "Joint Statement: Afghan Civil Society Response to Russian Federation's Recognition of Taliban",
      fa: "بیانیه جمعی: واکنش جامعه مدنی افغانستان به به رسمیت شناسی طالبان توسط فدراسیون روسیه",
      de: "Gemeinsame Erklärung: Reaktion der afghanischen Zivilgesellschaft auf die Anerkennung der Taliban durch die Russische Föderation"
    },
    files: [
      {
        language: "English",
        code: "en",
        name: "Joint_Statement_Russia_Taliban_Recognition_EN.pdf",
        url: "/announcements/Joint_Statement_Russia_Taliban_Recognition_EN.pdf",
        size: "1.6 MB"
      },
      {
        language: "Persian",
        code: "fa",
        name: "Joint_Statement_Russia_Taliban_Recognition_FA.pdf",
        url: "/announcements/Joint_Statement_Russia_Taliban_Recognition_FA.pdf",
        size: "1.7 MB"
      }
    ],
    description: {
      en: "Joint statement by Afghan civil society organizations, protest movements, and human rights groups expressing deep concern and strong objection to the Russian Federation's decision to recognize the Taliban as the governing authority in Afghanistan.",
      fa: "بیانیه جمعی نهادهای مدنی، جنبش‌های اعتراضی و سازمان‌های حقوق بشری افغانستان در بیان نگرانی عمیق و اعتراض شدید نسبت به تصمیم فدراسیون روسیه برای به رسمیت‌شناسی طالبان به عنوان ساختار حاکم در افغانستان.",
      de: "Gemeinsame Erklärung afghanischer zivilgesellschaftlicher Organisationen, Protestbewegungen und Menschenrechtsgruppen, die tiefe Besorgnis und starken Widerspruch gegen die Entscheidung der Russischen Föderation zur Anerkennung der Taliban als Regierungsbehörde in Afghanistan ausdrückt."
    }
  },
  {
    id: 6,
    date: "May 10 2025",
    title: {
      en: "Open Letter: Urgent Request for Support for Afghan Asylum Seekers with Islamabad Acceptance Letters",
      fa: "نامه سرگشاده: درخواست فوری برای حمایت و رسیدگی به وضعیت پناهجویان افغانستانی دارای نامه پذیرش در اسلام آباد",
    },
    files: [
      {
        language: "Persian",
        code: "fa", 
        name: "Open_Letter_Afghan_Asylum_Seekers_FA.pdf",
        url: "/announcements/Open_Letter_Afghan_Asylum_Seekers_FA.pdf",
        size: "1.8 MB"
      }
    ],
    description: {
      en: "An urgent open letter requesting immediate support and protection for Afghan asylum seekers who hold acceptance letters in Islamabad, highlighting their vulnerable situation and need for international protection.",
      fa: "نامه سرگشاده فوری درخواست حمایت و رسیدگی به وضعیت پناهجویان افغانستانی که دارای نامه پذیرش در اسلام آباد هستند، با تأکید بر وضعیت آسیب‌پذیر آنها و نیاز به حمایت بین‌المللی.",
    }
  },
  {
    id: 7,
    date: "March 12 2025",
    title: {
      en: "Joint Statement: Over 100 Organizations Support Spanish Judicial Process for Taliban Crimes",
      fa: "بیانیه مشترک: بیش از ۱۰۰ نهاد از روند قضایی اسپانیا برای جنایات طالبان حمایت می‌کنند",
      de: "Gemeinsame Erklärung: Über 100 Organisationen unterstützen den spanischen Gerichtsprozess für Taliban-Verbrechen"
    },
    files: [
      {
        language: "English",
        code: "en",
        name: "Joint_Statement_Spain_Judicial_Process_EN.pdf",
        url: "/announcements/Joint_Statement_Spain_Judicial_Process_EN.pdf",
        size: "1.8 MB"
      },
      {
        language: "Persian",
        code: "fa",
        name: "Joint_Statement_Spain_Judicial_Process_FA.pdf",
        url: "/announcements/Joint_Statement_Spain_Judicial_Process_FA.pdf",
        size: "1.9 MB"
      },
      {
        language: "Pashtu",
        code: "ps",
        name: "Joint_Statement_Spain_Judicial_Process_PS.pdf",
        url: "/announcements/Joint_Statement_Spain_Judicial_Process_PS.pdf",
        size: "1.8 MB"
      }
    ],
    description: {
      en: "Joint statement by over 100 organizations, associations, women's protest movements, and Afghan diaspora welcoming Spanish court proceedings against perpetrators of Taliban crimes and supporting justice for women, minorities, journalists, and victims.",
      fa: "بیانیه مشترک بیش از ۱۰۰ نهاد، سازمان، انجمن، جنبش‌های اعتراضی زنان و دیاسپورای افغانستان در استقبال از روند قضایی دادگاه اسپانیا علیه مرتکبان جنایات طالبان و حمایت از عدالت برای زنان، اقلیت‌ها، خبرنگاران و قربانیان.",
      de: "Gemeinsame Erklärung von über 100 Organisationen, Verbänden, Frauenprotestbewegungen und der afghanischen Diaspora, die die Gerichtsverfahren in Spanien gegen Täter von Taliban-Verbrechen begrüßen und Gerechtigkeit für Frauen, Minderheiten, Journalisten und Opfer unterstützen."
    }
  }
];

  const handleAnnouncementClick = (announcement) => {
    console.log('Announcement clicked:', announcement);
    setSelectedAnnouncement(announcement);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackToList = () => {
    setSelectedAnnouncement(null);
  };

  const getLanguageName = (code) => {
    const languages = {
      en: "English",
      fa: "فارسی",
      ps: "پښتو",
      ur: "اردو"
    };
    return languages[code] || code;
  };

  const getCurrentLanguageTitle = (announcement) => {
    const title = announcement.title[i18n.language] || announcement.title.en;
    console.log('Getting title for language:', i18n.language, 'Title:', title);
    return title;
  };

  const getCurrentLanguageDescription = (announcement) => {
    return announcement.description[i18n.language] || announcement.description.en;
  };

  // Single Announcement Detail View
  if (selectedAnnouncement) {
    console.log('Rendering detail view for:', selectedAnnouncement);
    return (
      <div className="announcements-page">
        <Navbar />
        
        <section className="announcement-detail-section py-5">
          <div className="container">
            <button 
              className="btn btn-outline-primary mb-4"
              onClick={handleBackToList}
            >
              <i className="fas fa-arrow-left me-2"></i>
              Back to Announcements
            </button>

            <div className="announcement-header text-center mb-5">
              <h1 className="announcement-title">
                {getCurrentLanguageTitle(selectedAnnouncement)}
              </h1>
              <div className="announcement-date">
                <i className="far fa-calendar me-2"></i>
                {selectedAnnouncement.date}
              </div>
              <p className="announcement-description lead mt-3">
                {getCurrentLanguageDescription(selectedAnnouncement)}
              </p>
            </div>

            <div className="files-section">
              <h3 className="section-subtitle text-center mb-4">
                Download Announcement in Different Languages
              </h3>
              
              <div className="row">
                {selectedAnnouncement.files.map((file, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div className="file-card text-center">
                      <div className="file-icon mb-3">
                        <i className="fas fa-file-pdf fa-3x text-danger"></i>
                      </div>
                      <h5 className="file-language">{file.language}</h5>
                      <p className="file-size text-muted small">{file.size}</p>
                      <a 
                        href={file.url} 
                        className="btn btn-primary btn-sm"
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-download me-2"></i>
                        Download PDF
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <Contact />
        <Donate />
        <Footer />
      </div>
    );
  }

  // Announcements List View
  console.log('Rendering list view');
  return (
    <div className="announcements-page">
      <Navbar />
      
      <section className="announcements-list-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="section-title">Official Announcements</h1>
            <p className="lead text">
              Latest official statements and announcements from Progressive Forces of Afghanistan Movement
            </p>
          </div>

          {announcementsData.length === 0 ? (
            <div className="text-center text-white">
              <p>No announcements available at the moment.</p>
            </div>
          ) : (
            <div className="row">
              {announcementsData.map((announcement) => (
                <div key={announcement.id} className="col-lg-6 mb-4">
                  <div 
                    className="announcement-card card shadow-sm h-100 animate__animated clickable-card"
                    onClick={() => handleAnnouncementClick(announcement)}
                    style={{ cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.transition = 'transform 0.3s ease';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <div className="card-body">
                      <div className="announcement-date mb-2">
                        <i className="far fa-calendar text-primary me-2"></i>
                        <strong>{announcement.date}</strong>
                      </div>
                      
                      <h5 className="announcement-card-title">
                        {getCurrentLanguageTitle(announcement)}
                      </h5>
                      
                      <p className="announcement-card-description">
                        {getCurrentLanguageDescription(announcement)}
                      </p>
                      
                      <div className="announcement-languages mt-3">
                        <small className="text-muted">
                          <i className="fas fa-language me-1"></i>
                          Available in: 
                          {announcement.files.map((file, index) => (
                            <span key={file.code} className="ms-1">
                              {getLanguageName(file.code)}
                              {index < announcement.files.length - 1 ? ',' : ''}
                            </span>
                          ))}
                        </small>
                      </div>
                      
                      <div className="announcement-action mt-3">
                        <span className="btn btn-outline-primary btn-sm">
                          View Announcement <i className="fas fa-arrow-right ms-1"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Contact />
      <Donate />
      <Footer />
    </div>
  );
};

export default Announcements;